import { css } from 'lit';
         export default css` 
         @charset "UTF-8";
/* ------------------------------------*\
    #BREAKPOINT VARIABLES
\*------------------------------------ */
/* ------------------------------------*\
    #TYPOGRAPHY APPLICATIONS
\*------------------------------------ */
/**
   * Visible focus outline 2px inside the element on a light background
   */
/**
   * Visible focus outline 2px inside the element on a dark background
   */
/**
   * Visible focus outline for elements on a light background
   */
/**
   * Invisible focus outline for elements that need a more visible
   * focus state for high-contrast mode
   */
/**
   * Visually hidden from display
   */
/**
   * style for text ellipsis
   */
/**
   * Popover attribute has default styling which comes from UA stylesheets which will be overridden here.
   */
/* ------------------------------------*\
    #VISIBILITY UTILITIES
\*------------------------------------ */
/* Completely remove from the flow and screen readers. */
.cat-u-is-hidden {
  display: none !important;
  visibility: hidden !important;
}

/* Completely remove from the flow but leave available to screen readers. */
.cat-u-is-vishidden {
  position: absolute !important;
  overflow: hidden;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  clip: rect(1px, 1px, 1px, 1px);
}

/**
 * Hide element at sm breakpoint 
 */
@media all and (min-width: 23.4375rem) {
  .cat-u-hide-sm {
    display: none !important;
  }
}

/**
 * Hide element at sm-2 breakpoint 
 */
@media all and (min-width: 35rem) {
  .cat-u-hide-sm-2 {
    display: none !important;
  }
}

/**
 * Hide element at md breakpoint 
 */
@media all and (min-width: 48rem) {
  .cat-u-hide-md {
    display: none !important;
  }
}

/**
 * Hide element at lg breakpoint 
 */
@media all and (min-width: 60rem) {
  .cat-u-hide-lg {
    display: none !important;
  }
}

/**
 * Hide element at xl breakpoint 
 */
@media all and (min-width: 75rem) {
  .cat-u-hide-xl {
    display: none !important;
  }
}

/**
 * Show element at sm breakpoint 
 */
@media all and (max-width: 23.4375rem) {
  .cat-u-show-sm {
    display: none !important;
  }
}

/**
 * Show element at sm-2 breakpoint 
 */
@media all and (max-width: 35rem) {
  .cat-u-show-sm-2 {
    display: none !important;
  }
}

/**
 * Show element at md breakpoint 
 */
@media all and (max-width: 48rem) {
  .cat-u-show-md {
    display: none !important;
  }
}

/**
 * Show element at lg breakpoint 
 */
@media all and (max-width: 60rem) {
  .cat-u-show-lg {
    display: none !important;
  }
}

/**
 * Show element at xl breakpoint 
 */
@media all and (max-width: 75rem) {
  .cat-u-show-xl {
    display: none !important;
  }
}

/* ------------------------------------*\
    #RESET
\*------------------------------------ */
/**
 * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/
 */
*,
::slotted(*),
*:before,
*:after {
  box-sizing: border-box;
}

:focus-visible {
  outline-color: var(--cat-theme-color-focus-ring);
}

/* ------------------------------------*\
    #DATEPICKER
\*------------------------------------ */
/**
 * 1) Calendar popup widget
 */
.cat-c-calendar {
  min-width: calc(var(--size-base-unit) * 40);
  width: var(--cat-c-calendar--width, auto);
  margin-block-start: 0;
  background-color: var(--cat-theme-color-background-default);
  position: relative;
  border-radius: var(--cat-theme-border-radius);
  padding: var(--cat-space-x-small);
}

/**
 * Navigation wrapper for previous, next and month sele
 */
.cat-c-calendar__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-block-end: var(--cat-space-x-small);
  height: calc(var(--size-base-unit) * 6);
}

/**
 * Displayed Month and Year above calendar dates
 */
.cat-c-calendar__month-selector-button {
  font-family: var(--cat-theme-typography-label-font-family);
  font-weight: var(--cat-theme-typography-label-font-weight);
  font-size: var(--cat-theme-typography-label-font-size);
  line-height: var(--cat-theme-typography-label-line-height);
  display: inline-flex;
  align-items: center;
  gap: var(--cat-space-x-small);
  background: none;
  cursor: pointer;
  border: 0;
  padding: var(--cat-space-x-small);
  text-align: center;
  color: var(--cat-theme-color-content-default);
  border-radius: var(--cat-border-radius-md);
}
.cat-c-calendar__month-selector-button:hover {
  color: var(--cat-theme-color-content-link-hover);
}
.cat-c-calendar__month-selector-button:active {
  color: var(--cat-theme-color-content-link-active);
}
.cat-c-calendar__month-selector-button:focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}

/**
 * Down-caret icon next to current month label
 */
.cat-c-calendar__month-selector-button-icon {
  --cat-icon-width: calc(var(--size-base-unit) * 2);
  --cat-icon-height: calc(var(--size-base-unit) * 2);
}

/**
 * Navigation buttons for previous/next month
 */
.cat-c-calendar__nav-btn {
  cursor: pointer;
  --cat-icon-width: calc(var(--size-base-unit) * 2);
  --cat-icon-height: calc(var(--size-base-unit) * 2);
  /**
   * When previous/next month is not selectable
   */
}
.cat-c-calendar__nav-btn[disabled], .cat-c-calendar__nav-btn[disabled]:focus, .cat-c-calendar__nav-btn[disabled]:hover {
  --cat-icon-fill: var(--cat-theme-color-content-disabled);
}

/**
 * Body wrapper for days
 */
.cat-c-calendar__table-container {
  text-align: center;
}

/**
 * Footer container in datepicker
 */
.cat-c-calendar__footer {
  padding: 0 var(--cat-space-medium) var(--cat-space-medium);
}

/**
 * Grid for displaying dates
 */
.cat-c-calendar__table {
  width: 100%;
}
.cat-c-calendar__table .cat-c-calendar__table-cell {
  padding: 0;
}
.cat-c-calendar__table .cat-c-calendar__table-row:last-child .cat-c-calendar__item {
  margin-block-end: 0;
}

/**
 * Grid header row spacing
 */
.cat-c-calendar__header-cell {
  font-family: var(--cat-theme-typography-label-sm-font-family);
  font-weight: var(--cat-theme-typography-label-sm-font-weight);
  font-size: var(--cat-theme-typography-label-sm-font-size);
  line-height: var(--cat-theme-typography-label-sm-line-height);
  text-transform: uppercase;
  color: var(--cat-theme-color-content-default);
  height: calc(var(--size-base-unit) * 6);
  font-weight: var(--cat-font-weight-bold);
  padding-block-end: var(--cat-space-x-small);
}

/**
 * Day buttons on calendar
 */
.cat-c-calendar__item {
  background: none;
  border: 1px solid transparent;
  border-radius: 50%;
  height: calc(var(--size-base-unit) * 5);
  width: calc(var(--size-base-unit) * 5);
  padding: 0;
  margin-block-end: var(--cat-space-x-small);
  position: relative;
  transition: background-color var(--cat-anim-fade-quick) var(--cat-anim-ease), color var(--cat-anim-fade-quick) var(--cat-anim-ease);
  /**
   * Hover
   */
  /**
   * Focus states for dates
   */
  /**
   * When day is Today but unavailable to select
   * 1) Display a dot underneath the date to indicate the present day
   */
  /**
   * When day is Today and available to select
   * 1) Display a dot underneath the date to indicate the present day
   */
  /**
   * When day is available to be selected
   */
  /**
   * Selected
   */
  /**
   * When focus is set to the active selected day
   */
  /**
   * When day is not selectable
   */
}
.cat-c-calendar__item:hover {
  background-color: var(--cat-theme-color-background-subtle);
  cursor: pointer;
  outline: none;
}
.cat-c-calendar__item:focus-visible {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-inset-focus-ring, -4px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-calendar__item:focus {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-inset-focus-ring, -4px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-calendar__item.is-today:after {
  content: "";
  width: calc(var(--size-base-unit) * 1);
  height: calc(var(--size-base-unit) * 1);
  background: var(--cat-theme-color-content-disabled);
  border-radius: 50%;
  position: absolute;
  inset-block-end: calc(var(--size-base-unit) * 0.125);
  inset-inline-start: calc(50% - var(--cat-space-3x-small));
}
.cat-c-calendar__item.is-today.is-available:after {
  background: var(--cat-theme-color-background-xstrong);
}
.cat-c-calendar__item.is-available {
  font-family: var(--cat-theme-typography-body-sm-font-family);
  font-weight: var(--cat-theme-typography-body-sm-font-weight);
  font-size: var(--cat-theme-typography-body-sm-font-size);
  line-height: var(--cat-theme-typography-body-sm-line-height);
  color: var(--cat-theme-color-content-default);
}
.cat-c-calendar__item.is-active, .cat-c-calendar__item.is-available.is-active {
  color: var(--cat-theme-color-content-knockout);
  background-color: var(--cat-theme-color-background-xstrong);
  /**
   * 1) Change current day dot indicator to knockout text color
   */
}
.cat-c-calendar__item.is-active.is-today:after, .cat-c-calendar__item.is-available.is-active.is-today:after {
  background: var(--cat-theme-color-content-knockout); /* 1 */
}
.cat-c-calendar__item.is-active:focus {
  box-shadow: inset 0 0 0 var(--cat-border-width-md) var(--cat-theme-color-border-strong);
}
.cat-c-calendar__item:disabled, .cat-c-calendar__item:disabled:focus, .cat-c-calendar__item:disabled:hover {
  color: var(--cat-theme-color-content-disabled);
  cursor: not-allowed;
  background: none;
}
.cat-c-calendar__item.is-active:hover {
  color: var(--cat-theme-color-content-knockout);
  background-color: var(--cat-theme-color-background-xstrong);
}
.cat-c-calendar__item.is-active:disabled {
  background-color: var(--cat-theme-color-button-background-disabled);
  color: var(--cat-theme-color-content-disabled);
}

/**
 * Month calendar popup
 */
.cat-c-calendar-month-panel--open {
  min-width: calc(var(--size-base-unit) * 40);
}

.cat-c-calendar__month-selector-popup {
  position: absolute;
  inset-inline-start: 0;
  inset-block-start: 0;
  width: 100%;
  height: 100%;
  overflow: auto;
  z-index: 1;
  background: var(--cat-theme-color-background-default);
}
.cat-c-calendar__month-selector-popup::-webkit-scrollbar {
  width: calc(var(--size-base-unit) * 0.5);
  height: calc(var(--size-base-unit) * 0.5);
}
.cat-c-calendar__month-selector-popup::-webkit-scrollbar-thumb {
  border-radius: 2px;
  background: var(--cat-theme-color-background-subtle-hover);
  height: calc(var(--size-base-unit) * 5);
}

/* ------------------------------------*\
    #MONTH SELECTOR
\*------------------------------------ */
.cat-c-month-selector {
  padding: var(--cat-space-x-small);
  min-width: min-content;
}

.cat-c-month-selector__list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.cat-c-month-selector__item {
  border-block-end: 1px solid var(--cat-theme-color-border-default);
  padding: var(--cat-space-x-small) 0;
  display: grid;
  grid-template-columns: min-content 1fr;
  gap: var(--cat-space-3x-small);
}
.cat-c-month-selector__item:last-of-type {
  border-block-end: none;
}

.cat-c-month-selector__sub-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr;
  gap: var(--cat-space-3x-small);
}

.cat-c-month-selector__year-heading {
  font-family: var(--cat-theme-typography-body-sm-font-family);
  font-weight: var(--cat-theme-typography-body-sm-font-weight);
  font-size: var(--cat-theme-typography-body-sm-font-size);
  line-height: var(--cat-theme-typography-body-sm-line-height);
  color: var(--cat-theme-color-content-subtle);
  margin: calc(var(--size-base-unit) * 1.375) 0 0;
}

.cat-c-month-selector__button {
  font-family: var(--cat-theme-typography-label-font-family);
  font-weight: var(--cat-theme-typography-label-font-weight);
  font-size: var(--cat-theme-typography-label-font-size);
  line-height: var(--cat-theme-typography-label-line-height);
  text-transform: uppercase;
  font-weight: var(--cat-font-weight-bold);
  background: none;
  border: 1px solid transparent;
  border-radius: 50%;
  min-height: calc(var(--size-base-unit) * 5);
  min-width: calc(var(--size-base-unit) * 5);
  padding: 0;
  position: relative;
  cursor: pointer;
  transition: background-color var(--cat-anim-fade-quick) var(--cat-anim-ease), color var(--cat-anim-fade-quick) var(--cat-anim-ease);
  color: var(--cat-theme-color-content-strong);
  /**
   * Hover/Focus styles
   */
  /**
   * Focus states for dates
   */
  /**
   * When month is current month
   * 1) Display a dot underneath the date to indicate the present day
   */
  /**
   * When month is current month but disabled
   * 1) Display a disabled dot underneath the date to indicate the present day
   */
  /**
   * Selected
   */
  /**
   * When month is not selectable
   */
  /**
   * When month is active and not selectable
   */
}
.cat-c-month-selector__button abbr {
  border-block-end: 0;
  text-decoration: none;
}
.cat-c-month-selector__button.cat-c-month-selector__button-focus-active, .cat-c-month-selector__button:hover {
  background-color: var(--cat-theme-color-background-subtle);
  cursor: pointer;
  outline: none;
}
.cat-c-month-selector__button:not(:disabled).cat-c-month-selector__button-focus-active {
  outline: 2px solid var(--cat-theme-color-focus-ring);
  outline-offset: var(--cat-theme-offset-focus-ring, 2px);
  transition: all var(--cat-anim-fade-quick) var(--cat-anim-ease);
}
.cat-c-month-selector__button.is-current:after {
  content: "";
  width: calc(var(--size-base-unit) * 1);
  height: calc(var(--size-base-unit) * 1);
  background: var(--cat-theme-color-background-xstrong);
  border-radius: 50%;
  position: absolute;
  inset-block-end: calc(var(--size-base-unit) * 0.125);
  inset-inline-start: calc(50% - var(--cat-space-3x-small));
}
.cat-c-month-selector__button.is-current:disabled:after {
  background: var(--cat-theme-color-content-disabled);
}
.cat-c-month-selector__button.is-active, .cat-c-month-selector__button.is-available.is-active {
  color: var(--cat-theme-color-content-knockout);
  background-color: var(--cat-theme-color-background-xstrong);
  /**
   * 1) Change current day dot indicator to knockout text color
   */
}
.cat-c-month-selector__button.is-active.is-current:after, .cat-c-month-selector__button.is-available.is-active.is-current:after {
  background: var(--cat-theme-color-content-knockout); /* 1 */
}
.cat-c-month-selector__button:disabled, .cat-c-month-selector__button:disabled:focus, .cat-c-month-selector__button:disabled:hover {
  color: var(--cat-theme-color-content-disabled);
  cursor: not-allowed;
  background: none;
}
.cat-c-month-selector__button.is-active:disabled {
  background: var(--cat-theme-color-button-background-disabled);
}

.cat-c-calendar-month-panel--open :is(.cat-c-calendar__header, .cat-c-calendar__table-container) {
  opacity: 0;
}
`;
       